import { render, staticRenderFns } from "./TicketsInfo.vue?vue&type=template&id=1941042f&scoped=true"
import script from "./TicketsInfo.vue?vue&type=script&lang=js"
export * from "./TicketsInfo.vue?vue&type=script&lang=js"
import style0 from "./TicketsInfo.vue?vue&type=style&index=0&id=1941042f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1941042f",
  null
  
)

export default component.exports